export default __webpack_public_path__ + "static/media/sac-logo-2a.f1718944.png";